import InstitutionalHero from "components/Institutional/InstitutionalHero";
/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultNavbar from "components/Institutional/InstitutionalNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import sagradoCorazonDeJesus from "assets/images/sagradoCorazonDeJesus.jpg";
import { ContenedorPrincipal } from "components/ContenedorPrincipal";
import NoticiasFetch from "./sections/NoticiasFetch";
import BotonWsp from "components/BotonWsp";

// import Information from "./sections/Information";
// import DesignBlocks from "./sections/DesignBlocks";
// import Pages from "./sections/Pages";

function Noticias() {
  return (
    <MKBox position="relative">
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "https://www.creative-tim.com/product/material-kit-react",
          label: "free download",
          color: "info",
        }}
        sticky
        brand={"Instituto Sagrado Corazón"}
      />
      <InstitutionalHero image={sagradoCorazonDeJesus} title="" />
      <ContenedorPrincipal>
        <NoticiasFetch />
        {/* <Pages /> */}
      </ContenedorPrincipal>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
      <BotonWsp />
    </MKBox>
  );
}

export default Noticias;
